// extracted by mini-css-extract-plugin
export default {"root":"VigboFeature__root--Q0ikS"};